// extracted by mini-css-extract-plugin
module.exports = {"container":"header-menu_container__djnxU","open":"header-menu_open__X3M1u","overflow":"header-menu_overflow__Jck3D"};